<template>
  <div class="page-account">
    <div class="mod-loading" v-if="loading">
      <a-icon type="loading"></a-icon>
    </div>
    <div class="mod-empty" v-if="!loading && !userInfo">
      服务异常，请刷新页面重试！
    </div>
    <template v-if="!loading && userInfo">
      <div class="mod-welcome">
        <span v-if="userType === 3">
          {{ userInfo.fullName || userInfo.phone }}, 欢迎您
        </span>
        <span v-else>
          {{ userInfo.chiSurname ? userInfo.fullName : userInfo.phone }}{{ userInfo.gender | sex }}, 欢迎您
        </span>
         <!-- NOTE: 根据配置判断 -->
        <template v-if="hasAuth">
          <template v-if="userType === 0">
            <a-tooltip>
              <template slot="title">
                账号已实名认证
              </template>
              <span v-if="userInfo.authStatus === 4" class="isauth yes"></span>
            </a-tooltip>
            <a-tooltip>
              <template slot="title">
                账号未实名认证
              </template>
                <router-link v-if="userInfo.authStatus !== 4" class="isauth no" to="/authenticate?type=auth"></router-link>
            </a-tooltip>
          </template>
        </template>
      </div>
      <div class="mod-anonymity" v-if="userType === 0 && !userInfo.fullName">
        <p>完善个人信息，享受更多会员权益</p>
        <ul class="benefits">
          <li>
            <user-icon type="icon-liwu"></user-icon>
            <div>会员礼遇</div>
          </li>
          <li>
            <user-icon type="icon-jifen"></user-icon>
            <div>积分累积</div>
          </li>
          <li>
            <user-icon type="icon-xunzhang"></user-icon>
            <div>积分兑换</div>
          </li>
          <li>
            <user-icon type="icon-huangguan"></user-icon>
            <div>更多权益</div>
          </li>
        </ul>
        <div class="action">
          <a-button size="large" @click="onAddInfo" v-if="userInfo.authStatus === 4">完善个人资料</a-button>
          <a-button size="large" @click="onFFPBinding">绑定金鹏卡</a-button>
          <a class="ant-btn ant-btn-primary ant-btn-lg" href="https://ffp.hnair.com/FFPClub/member/registerConfirm" target="_blank">加入金鹏俱乐部</a>
        </div>
      </div>
      <template v-else>
        <div v-if="userType === 0" class="mod-ffp clearfix">
          <template v-if="ffpUserInfo">
            <div class="card">
              <img :src="ffpUserInfo.tierImg" alt="金鹏会员卡" />
            </div>
            <ul>
              <li>
                <span class="label">金鹏卡号</span>
                <span class="value">
                  <span class="card-number">{{ desensitize(ffpUserInfo.cid, '*', 4, 7, !cardVisible) }}</span>
                  <a-icon class="eye-icon" :type="cardVisible ? 'eye' : 'eye-invisible'" @click="cardVisible =!cardVisible" /> </span>
              </li>
              <li>
                <span class="label">总积分金额</span>
                <span class="value">{{ ffpUserInfo.accountBalance }}</span>
              </li>
              <li>
                <span class="label">金鹏卡等级</span>
                <span class="value">{{ realTierName | tierName }}</span>
              </li>
              <li>
                <span class="label">积分过期日</span>
                <span class="value">{{ ffpUserInfo.accountExpiredDate | accountExpiredDate }}</span>
              </li>
              <li>
                <span class="label">{{ realTierName | upgradeStatus}}所需定级积分</span>
                <span class="value">{{ memberTierProgress | upgradeQpTotal(realTierName) }}</span>
                <!-- <span class="value">{{ memberTierProgress.upgradeQpTotal ?? '-' }}</span> -->
              </li>
              <li>
                <span class="label">{{ realTierName | upgradeStatus}}所需定级航段</span>
                <span class="value">{{ memberTierProgress | upgradeSegTotal(realTierName) }}</span>
                <!-- <span class="value">{{ memberTierProgress.upgradeSegTotal ?? '-' }}</span> -->
              </li>
            </ul>
          </template>
          <template v-else>
            <ul class="benefits">
              <li>
                <user-icon type="icon-liwu"></user-icon>
                <div>会员礼遇</div>
              </li>
              <li>
                <user-icon type="icon-jifen"></user-icon>
                <div>积分累积</div>
              </li>
              <li>
                <user-icon type="icon-xunzhang"></user-icon>
                <div>积分兑换</div>
              </li>
              <li>
                <user-icon type="icon-huangguan"></user-icon>
                <div>更多权益</div>
              </li>
            </ul>
            <div class="action">
              <a-button size="large" @click="onFFPBinding">绑定金鹏卡</a-button>
              <a class="ant-btn ant-btn-primary ant-btn-lg" href="https://ffp.hnair.com/FFPClub/member/registerConfirm" target="_blank">加入金鹏俱乐部</a>
            </div>
          </template>
        </div>
        <div v-if="agentInfo" class="mod-base-info mod-group">
          <div class="cell-header">
            <h3>公司信息</h3>
          </div>
          <div class="cell-body clearfix">
            <div class="base-info">
              <dl>
                <dt>企业名称</dt>
                <dd>{{ agentInfo.chiName }}</dd>
              </dl>
              <dl>
                <dt>业务联系人</dt>
                <dd>{{ agentInfo.contactName }}</dd>
              </dl>
              <dl>
                <dt>OFFICE号</dt>
                <dd>{{ agentInfo.officeNo }}</dd>
              </dl>
              <dl>
                <dt>地区</dt>
                <dd>{{ agentInfo.countryDesc }}{{ agentInfo.provinceDesc }}{{ agentInfo.cityDesc }}</dd>
              </dl>
            </div>
            <div class="more-info">
              <dl>
                <dt>企业类型</dt>
                <dd>{{ agentInfo.agentType | agentType }}</dd>
              </dl>
              <dl>
                <dt>所属营业部</dt>
                <dd>{{ agentInfo.department || '-' }}</dd>
              </dl>
              <dl>
                <dt>办公电话</dt>
                <dd>{{ agentInfo.phoneNo || '-' }}</dd>
              </dl>
            </div>
          </div>
        </div>
        <div class="mod-base-info mod-group">
          <div class="cell-header">
            <h3>基本信息
              <span v-if="userType !== 3 && !(userType === 0 && (userInfo.authStatus === 4 || ffpUserInfo))" class="edit" title="编辑信息" @click="onAddInfo">修改<user-icon class="icon-edit" type="icon-bianji"></user-icon></span>
            </h3>
          </div>
          <div v-if="userType === 0" class="cell-body clearfix">
            <div class="base-info">
              <dl>
                <dt>姓名</dt>
                <dd>{{ userInfo.chiSurname ? userInfo.fullName : '-' }}</dd>
              </dl>
              <dl>
                <dt>拼音姓名</dt>
                <dd>{{ userInfo | pinyin }}</dd>
              </dl>
              <dl>
                <dt>性别</dt>
                <dd>{{ userInfo.gender | gender }}</dd>
              </dl>
            </div>
            <div class="more-info">
              <dl>
                <dt>手机号码</dt>
                <dd>
                  <span class="value">+{{ userInfo.areaCode || '86' }} {{ userInfo.phone || '-' | sign }}</span>
                  <user-icon v-if="userInfo.phoneStatus !== 0" class="icon-warn" type="icon-jinggaoicon"></user-icon>
                  <span class="verify success" v-if="userInfo.phoneStatus === 0">
                    <user-icon type="icon-roundcheckfill"></user-icon>
                    {{ userInfo.phoneStatus | contactStatus }}
                    <user-icon class="icon-edit" type="icon-bianji" title="修改手机" @click="onBindEdit('mobile', 'change', userInfo.phone || '')"></user-icon>
                  </span>
                  <span class="verify error" v-else>
                    <user-icon type="icon-roundclosefill"></user-icon>
                    {{ userInfo.phoneStatus | contactStatus }}
                    <user-icon class="icon-edit" type="icon-bianji" title="绑定手机" @click="onBindEdit('mobile', 'bind', userInfo.phone || '')"></user-icon>
                  </span>
                </dd>
              </dl>
              <dl>
                <dt>邮箱</dt>
                <dd>
                  <span class="value">{{ userInfo.email || '-' | sign }}</span>
                  <user-icon v-if="userInfo.emailStatus !== 0" class="icon-warn" type="icon-jinggaoicon"></user-icon>
                  <span class="verify success" v-if="userInfo.emailStatus === 0">
                    <user-icon type="icon-roundcheckfill"></user-icon>
                    {{ userInfo.emailStatus | contactStatus }}
                    <user-icon class="icon-edit" type="icon-bianji" title="修改邮箱" @click="onBindEdit('email', 'change', userInfo.email || '')"></user-icon>
                  </span>
                  <span class="verify error" v-else>
                    <user-icon type="icon-roundclosefill"></user-icon>
                    {{ userInfo.emailStatus | contactStatus }}
                    <user-icon class="icon-edit" type="icon-bianji" title="绑定邮箱" @click="onBindEdit('email', 'bind', userInfo.email || '')"></user-icon>
                  </span>
                </dd>
              </dl>
              <dl>
                <dt>地区</dt>
                <dd>{{ userInfo | address }}</dd>
              </dl>
            </div>
          </div>
          <div v-if="userType === 1 || userType === 2" class="cell-body clearfix">
            <div class="base-info">
              <dl>
                <dt>用户名</dt>
                <dd>{{ userInfo.login }}</dd>
              </dl>
              <dl>
                <dt>业务联系人</dt>
                <dd>{{ userInfo.fullName }}</dd>
              </dl>
            </div>
            <div class="more-info">
              <dl>
                <dt>移动电话</dt>
                <dd>{{ userInfo.phone || '-' }}</dd>
              </dl>
              <dl>
                <dt>电子邮箱</dt>
                <dd>{{ userInfo.email || '-' }}</dd>
              </dl>
            </div>
          </div>
          <div v-if="userType === 3" class="cell-body clearfix">
            <div class="base-info">
              <dl>
                <dt>用户名</dt>
                <dd>{{ userInfo.loginName }}</dd>
              </dl>
              <dl>
                <dt>姓名</dt>
                <dd>{{ userInfo.fullName }}</dd>
              </dl>
            </div>
            <div class="more-info">
              <dl>
                <dt>移动电话</dt>
                <dd>{{ userInfo.phone || '-' }}</dd>
              </dl>
              <dl>
                <dt>电子邮箱</dt>
                <dd>{{ userInfo.email || '-' }}</dd>
              </dl>
            </div>
          </div>
        </div>
        <div v-if="userType === 0" class="mod-certificate mod-group">
          <div class="cell-header">
            <h3>证件信息</h3>
          </div>
          <div class="cell-body">
            <dl v-for="cert in userInfo.userCerts" :key="cert.id">
              <dt>{{ cert.certType | certType }}</dt>
              <dd>{{ cert.certNo }}</dd>
              <dd class="more">
                <!-- <a-popover overlayClassName="certificate-detail-popover" placement="bottomLeft" trigger="click">
                  <div slot="content">
                    <dl>
                      <dt>{{ cert.certType | certType }}: </dt>
                      <dd>{{ cert.certNo }}</dd>
                    </dl>
                  </div>
                  <span>查看</span>
                </a-popover> -->
                <span class="edit" v-if="!(userType === 0 && (userInfo.authStatus === 4 || ffpUserInfo))" @click="onAddCert('modify', cert)">修改<user-icon class="icon-edit" type="icon-bianji"></user-icon></span>
              </dd>
            </dl>
            <div v-if="!userInfo.userCerts || !userInfo.userCerts.length" class="empty">暂无证件信息，请添加</div>
            <div class="add" @click="onAddCert('add')">
              <user-icon type="icon-roundaddfill"></user-icon>
              添加证件
            </div>
          </div>
          <div class="cell-footer">
            <h4>温馨提示</h4>
            <p>如您是金鹏会员，您档案中的证件信息将用于飞行积分的自动识别累计，请添加您本人真实的有效乘机证件。<br/>如需修改证件信息或删除错误的证件，请致电{{ app.name }}服务热线{{ app.hotline }}为您进行修改。</p>
          </div>
        </div>
      </template>
      <div v-if="(userType === 0 && ffpUserInfo) || userType === 1" class="mod-password mod-group">
        <div class="cell-header">
          <h3>密码信息</h3>
        </div>
        <div class="cell-body">
          <router-link :to="`/password?type=${passwordType}`">
            {{ userType === 1 ? (userInfo.hasPwd ? '修改密码' : '设置密码') : '修改密码' }}
            <user-icon class="icon-edit" type="icon-bianji"></user-icon>
          </router-link>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import moment from 'moment'
import { get, subtract } from 'lodash'
import { fetchInfo, fetchAgentInfo } from '@/api/member'
import { tierNameMap, tierNameImageMap } from '@/dicts/member'
import { desensitize } from '@/utils/util'
import fromApp from '@/utils/from'
import './index'

const regEmail = /^[a-z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?(?:\.[a-z0-9](?:[a-z0-9-]{0,61}[a-z0-9])?)*$/i

const certTypeMap = {
  5: '身份证',
  2: '有效护照',
  207: '港澳台居民居住证',
  206: '台胞证',
  6: '军官证',
  3: '士兵证',
  14: '其他证件'
}
const agentTypeMap = {
  AGENT: '旅行社',
  TRAVEL: '代理人',
  CORP: '机构客户'
}
const contactStatus = {
  8: '易主',
  0: '已验证',
  2: '未验证',
  '-1': '未绑定',
  '-2': '删除'
}

export default {
  data () {
    return {
      userType: 0,
      userInfo: null,
      ffpUserInfo: null,
      memberTierProgress: null,
      agentInfo: null,
      loading: true,
      app: null,
      airline: window.__MICRO_ROOT__?.airline,
      authTypeMenus: [],
      tierNameImageMap,
      cardVisible: false
    }
  },
  created () {
    this.getCmsData()

    const userInfo = this.$ls.get('USER_CENTER_INFO') || {}
    this.userType = userInfo.userType

    if (userInfo.userType === 0) {
      this.fetch()
    } else if (userInfo.userType === 1 || userInfo.userType === 2) {
      this.fetchAgent()
    } else if (userInfo.userType === 3) {
      this.userInfo = this.$ls.get('USER_CENTER_INFO')
      this.loading = false
    }

    this.app = fromApp()
  },
  computed: {
    hasAuth () {
      const { authTypeMenus = [] } = this
      return authTypeMenus.filter(item => item.enable)?.length > 0
    },
    realTierName () {
      const { optimalTier, tierName } = this.ffpUserInfo
      return optimalTier || tierName
    },
    passwordType () {
      const { userInfo, userType } = this
      // 0 - 散客/1 - 代理人
      if (userType === 0) {
        return 'newChange'
      } else {
        return userInfo.hasPwsd ? 'change' : 'new'
      }
    }
  },
  methods: {
    async getCmsData () {
      const pageCmsData = (await window.__MICRO_ROOT__?.cms?.getPageData()) ?? {}
      this.authTypeMenus = get(pageCmsData, 'authenticate-config.menus') ?? []
    },
    async fetch () {
      try {
        const { tierNameImageMap } = this
        const data = await fetchInfo({})
        this.userInfo = data.user

        if (data.ffpUserInfo && (data.ffpUserInfo.tierName || data.ffpUserInfo.optimalTier)) {
          const tierName = data.ffpUserInfo.optimalTier ? data.ffpUserInfo.optimalTier : data.ffpUserInfo.tierName
          data.ffpUserInfo.tierImg = require(`./images/${tierNameImageMap[tierName]}.png`)
        }

        this.ffpUserInfo = data.ffpUserInfo || null
        this.memberTierProgress = data.memberTierProgress || null
        this.loading = false

        this.$ls.set('USER_CENTER_INFO', data.user)
      } catch (err) {
        this.loading = false
        this.$message.error(err.message)
      }
    },
    async fetchAgent () {
      try {
        const data = await fetchAgentInfo({})

        this.agentInfo = data.agentInfo
        this.userInfo = data.agentUser
        this.loading = false
      } catch (err) {
        this.loading = false
        this.$message.error(err.message)
      }
    },
    showAuthTips () {
      if (this.userInfo.authStatus !== 4) {
        this.$message.warn('请先完成实名认证！')
        return true
      }
      return false
    },
    // 完善个人资料
    onAddInfo () {
      if (this.showAuthTips()) return
      const { userType } = this

      this.$router.push({
        path: userType === 0 ? '/infomation' : '/infomation-agent'
      })
    },
    // 手机、邮箱编辑
    onBindEdit (type, action, value) {
      if (this.showAuthTips()) return
      this.$router.push({
        path: 'binding',
        query: {
          action,
          type,
          value
        }
      })
    },
    // 绑定金鹏卡
    onFFPBinding () {
      this.$router.push({
        path: 'ffp-binding'
      })
    },
    // 添加证件
    onAddCert (action, value = {}) {
      if (this.showAuthTips()) return
      this.$router.push({
        path: 'certificate',
        query: {
          action,
          ...value
        }
      })
    },
    desensitize
  },
  filters: {
    sex (value) {
      if (typeof value === 'undefined' || value === null) {
        return ''
      }

      return value ? '先生' : '女士'
    },
    address (value) {
      if (typeof value === 'undefined') {
        return '-'
      }

      if (!value.countryDesc && !value.provinceDesc && !value.cityDesc) {
        return '-'
      }

      return `${value.countryDesc || ''} ${value.provinceDesc || ''} ${value.cityDesc || ''}`
    },
    pinyin (value) {
      if (typeof value === 'undefined') {
        return '-'
      }

      if (!value.engSurname && !value.engName) {
        return '-'
      }

      return `${value.engSurname || ''} ${value.engName || ''}`
    },
    certType (value) {
      return certTypeMap[value] || '其他证件'
    },
    tierName (value) {
      return tierNameMap[value] || '普卡'
    },
    upgradeStatus (value) {
      return tierNameMap[value] === '白金卡' ? '保级' : '升级'
    },
    upgradeQpTotal (memberTierProgress, realTierName) {
      const total = tierNameMap[realTierName] === '白金卡'
        ? subtract(memberTierProgress.requalifyGradeQpTotal, memberTierProgress.requalifyGradeQpCurrent)
        : subtract(memberTierProgress.upgradeQpTotal, memberTierProgress.upgradeQpCurrent)
      return total
    },
    upgradeSegTotal (memberTierProgress, realTierName) {
      const total = tierNameMap[realTierName] === '白金卡'
        ? subtract(memberTierProgress.requalifyGradeSegTotal, memberTierProgress.requalifyGradeSegCurrent)
        : subtract(memberTierProgress.upgradeSegTotal, memberTierProgress.upgradeSegCurrent)
      return total
    },
    sign (value) {
      if (!value || value === '-') {
        return '-'
      }

      if (regEmail.test(value)) {
        const idx = value.indexOf('@')
        const val = value.substr(0, idx)
        const suffix = value.substr(idx)

        const len = parseInt(val.length / 2)
        return `${val.substr(0, len)}${'*'.repeat(len)}${suffix}`
      }

      const len = parseInt(value.length / 2)
      return `${value.substr(0, len)}${'*'.repeat(len)}`
    },
    agentType (value) {
      if (!value) {
        return '-'
      }

      return agentTypeMap[value] || value
    },
    accountExpiredDate (date) {
      if (!date) {
        return '-'
      }

      const dateTime = moment(date, 'MM/DD/YYYY')

      return dateTime.isValid() ? dateTime.format('YYYY-MM-DD') : '-'
    },
    contactStatus (value) {
      if (typeof value === 'undefined') {
        return '-'
      }

      return contactStatus[value] || value
    },
    gender (value) {
      if (!parseInt(value)) {
        return '-'
      }

      return value ? '男' : '女'
    }
  }
}
</script>
